export default {
  GET_LOADING_STATE: (state) => {
    return state.isLoading;
  },
};
